import { render, staticRenderFns } from "./StackCard.vue?vue&type=template&id=e9e3448e&scoped=true&"
import script from "./StackCard.vue?vue&type=script&lang=js&"
export * from "./StackCard.vue?vue&type=script&lang=js&"
import style0 from "./StackCard.vue?vue&type=style&index=0&id=e9e3448e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e3448e",
  null
  
)

export default component.exports